import { X } from "lucide-react";
import { useTranslate } from "ra-core";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";

/** Shared chrome of the mini-games: step label, progress bar and a « Quitter » button. */
export const GameFrame = ({
  step,
  current,
  total,
  onQuit,
  children,
}: {
  step: string;
  current: number;
  total: number;
  onQuit: () => void;
  children: ReactNode;
}) => {
  const t = useTranslate();
  const percent = total > 0 ? Math.round((current / total) * 100) : 0;
  return (
    <section className="flex flex-col gap-4 rounded-xl border bg-card p-4 shadow-sm sm:p-6">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-muted-foreground">
          {step}
        </span>
        <Button variant="ghost" size="sm" onClick={onQuit}>
          <X className="size-4" aria-hidden="true" />
          {t("gavion.training.game.quit")}
        </Button>
      </div>
      <div
        role="progressbar"
        aria-label={step}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
        className="h-1.5 w-full overflow-hidden rounded-full bg-primary/15"
      >
        <div
          className="h-full rounded-full bg-primary motion-safe:transition-[width] motion-safe:duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
      {children}
    </section>
  );
};
